import React, { Component, ChangeEvent } from "react";
import { Button, FormControlLabel, Radio, RadioGroup, FormControl } from "@mui/material";

import { IFilterParams } from "ag-grid-community";
import { IFilterReactComp } from "ag-grid-react";
import styles from "./DatePickerFilter.module.scss";
import Flatpickr from "react-flatpickr";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import moment from "moment";
import { AddCalendarForDatePicker } from "components/app/AddCalendarForDatePicker";

interface ConciergeFilterParams {
  radioValue: string;
  filterActive: boolean;
  pickDate: Date[];
  nextDays: string;
  userInputDays: string;
  userInputDate: Date[];
}

class ConciergeFilter
  extends Component<IFilterParams, ConciergeFilterParams>
  implements IFilterReactComp
{
  private title: string;
  constructor(props: IFilterParams) {
    super(props);
    this.state = {
      filterActive: false,
      radioValue: "",
      pickDate: [],
      nextDays: "",
      userInputDays: "",
      userInputDate: [],
    };

    this.onButtonClick = this.onButtonClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.title = props.colDef.headerName!;
  }

  // Return true if the filter is active. If active then 1) the grid will show the filter icon in the column
  // header and 2) the filter will be included in the filtering of the data.
  isFilterActive() {
    return this.state.filterActive;
  }

  doesFilterPass() {
    return true;
  }

  getModel() {
    const { filterActive, radioValue, pickDate, nextDays, userInputDays, userInputDate } =
      this.state;

    const getUserInputDateString = () => {
      if (!!pickDate?.length) {
        const transformedPickStartDate = moment(pickDate[0]).format("YYYY-MM-DD");
        const transformedPickEndDate = moment(pickDate[1]).format("YYYY-MM-DD");
        return transformedPickStartDate + "|" + transformedPickEndDate;
      } else if (!!userInputDate?.length) {
        const transformedUserInputStartDate = moment(userInputDate[0]).format("YYYY-MM-DD");
        const transformedUserInputEndDate = moment(userInputDate[1]).format("YYYY-MM-DD");
        return transformedUserInputStartDate + "|" + transformedUserInputEndDate;
      } else {
        return "";
      }
    };

    if (filterActive) {
      return {
        filterType: "expandFilter",
        type: "equals",
        filter: radioValue,
        customizedParam: {
          pickDate: pickDate,
          nextDays: nextDays,
          userInputDays: userInputDays,
          userInputDate: userInputDate,
          userInputDateString: getUserInputDateString(),
        },
      };
    } else {
      return null;
    }
  }

  setModel(model: any) {
    if (!!model) {
      const { filter, customizedParam } = model;
      if (filter && customizedParam) {
        const { pickDate, nextDays, userInputDays, userInputDate } = customizedParam;
        this.setState(
          {
            radioValue: filter ?? "",
            filterActive: true,
            pickDate: pickDate,
            nextDays: nextDays,
            userInputDays: userInputDays,
            userInputDate: userInputDate,
          },
          () => {
            this.props.filterChangedCallback();
          }
        );
      }
    } else {
      this.setState(
        {
          radioValue: "",
          filterActive: false,
          pickDate: [],
          nextDays: "",
          userInputDays: "",
          userInputDate: [],
        },
        () => {
          this.props.filterChangedCallback();
        }
      );
    }
  }

  onButtonClick(type: "clear" | "apply") {
    switch (type) {
      case "clear":
        return () => {
          this.setState(
            {
              radioValue: "",
              filterActive: false,
              nextDays: "",
              pickDate: [],
              userInputDays: "",
              userInputDate: [],
            },
            () => {
              this.props.filterChangedCallback();
            }
          );
        };
      case "apply":
        return () => {
          this.setState(
            {
              filterActive: true,
            },
            () => {
              this.props.filterChangedCallback();
            }
          );
        };
    }
  }

  handleChange(_event: ChangeEvent<HTMLInputElement>, value: string) {
    this.setState({
      radioValue: value,
      pickDate: [],
      nextDays: "",
      userInputDays: "",
      userInputDate: [],
    });
  }

  onDateChange(pickDate: Date[]) {
    this.setState({
      pickDate: pickDate,
      nextDays: "",
      userInputDays: "",
      userInputDate: [],
    });
  }

  handleInNextChange = (event: any) => {
    this.setState({
      nextDays: event.target.value,
      pickDate: [],
      userInputDays: "",
      userInputDate:
        event.target.value !== "userInput"
          ? [
              new Date(),
              new Date(
                new Date().getTime() + Math.max(event.target.value - 1, 0) * 24 * 3600 * 1000
              ),
            ]
          : [],
    });
  };

  handleUserInputFocus = () => {
    this.setState({
      pickDate: [],
      nextDays: "userInput",
      userInputDate: [],
    });
  };

  handleUserInputChange = (event: any) => {
    event.target.value =
      event.target.value.replace(/\D/g, "") > 999 ? 999 : event.target.value.replace(/\D/g, "");
    this.setState({
      userInputDays: event.target.value,
      userInputDate: [
        new Date(),
        new Date(new Date().getTime() + Math.max(event.target.value - 1, 0) * 24 * 3600 * 1000),
      ],
    });
  };

  render() {
    const { filterActive, radioValue, pickDate, nextDays, userInputDays } = this.state;

    return (
      <div>
        <div>
          <p className={styles.filterTitle}>{this.title}</p>
        </div>
        <div
          className={styles.filterWrapper}
          style={{ justifyContent: "flex-start" }}
        >
          <FormControl component="fieldset">
            <RadioGroup
              onChange={this.handleChange}
              value={radioValue}
            >
              <FormControlLabel
                value="Active"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />
                }
                label="Active"
              />
              <div className={radioValue === "Active" ? styles.pickDateShow : styles.pickDateHide}>
                <Flatpickr
                  options={{
                    mode: "range",
                    dateFormat: "m/d/Y",
                    animate: true,
                  }}
                  value={pickDate}
                  onChange={this.onDateChange}
                  render={({ value: pickDate }, ref) => AddCalendarForDatePicker(pickDate, ref)}
                />
                <FormControl
                  component="fieldset"
                  className={styles.orInNextWrpper}
                >
                  <FormLabel
                    component="legend"
                    className={styles.orInNextTitle}
                  >
                    Or in next
                  </FormLabel>
                  <RadioGroup
                    aria-label="orInNext"
                    name="orInNext"
                    value={nextDays}
                    className={styles.orInNextRadioGroup}
                    onChange={this.handleInNextChange}
                  >
                    {["7", "15", "30", "45", "60", "90", "userInput"].map((value) => {
                      return value === "userInput" ? (
                        <FormControlLabel
                          key={value}
                          value={value}
                          control={
                            <Radio
                              size="small"
                              color="primary"
                            />
                          }
                          label={
                            <span>
                              <TextField
                                className={styles.orInNextUserInput}
                                onChange={this.handleUserInputChange}
                                onFocus={this.handleUserInputFocus}
                                value={userInputDays}
                                variant="standard"
                              />
                              <span> Day(s)</span>
                            </span>
                          }
                        />
                      ) : (
                        <FormControlLabel
                          key={value}
                          value={value}
                          control={
                            <Radio
                              size="small"
                              color="primary"
                            />
                          }
                          label={`${value} Days`}
                        />
                      );
                    })}
                  </RadioGroup>
                </FormControl>
              </div>
              <FormControlLabel
                value="Not Started"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />
                }
                label="Not Started"
              />
              <FormControlLabel
                value="Expired"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />
                }
                label="Expired"
              />
              <FormControlLabel
                value="null"
                control={
                  <Radio
                    size="small"
                    color="primary"
                  />
                }
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </div>
        <div className="ag-filter-apply-panel">
          <Button
            variant="text"
            disabled={!filterActive}
            onClick={this.onButtonClick("clear")}
            className="ag-standard-button ag-filter-apply-panel-button"
          >
            Reset filter
          </Button>
          <Button
            disabled={!!!radioValue}
            variant="text"
            onClick={this.onButtonClick("apply")}
            className="ag-standard-button ag-filter-apply-panel-button"
          >
            Apply filter
          </Button>
        </div>
      </div>
    );
  }
}

export default ConciergeFilter;
